import { useCallback, useRef } from 'react'
import { useDispatch } from 'react-redux'
import EditorField from 'builder/components/EditorField'
import Select from 'builder/components/Select'
import { useI18n } from 'builder/hooks/useI18n'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { actions } from 'builder/modules/resumeEditor'

export const Spouse = () => {
  const { i18n } = useI18n()

  const options = useRef([
    { id: true, name: i18n.t('builder.resume_editor.professional_summary.spouse_options.true') },
    { id: false, name: i18n.t('builder.resume_editor.professional_summary.spouse_options.false') },
  ])
  const { updateSimpleField } = actions
  const married = useTypedSelector(state => state.resumeEditor.resume?.married || false)
  const dispatch = useDispatch()

  const handleSelect = useCallback(
    (value: boolean) => {
      dispatch(updateSimpleField({ name: 'married', value }))
    },
    [dispatch, updateSimpleField],
  )

  return (
    <>
      <EditorField>
        <Select
          label={i18n.t('builder.resume_editor.professional_summary.spouse')}
          selected={married}
          onSelect={handleSelect}
          options={options.current}
        />
      </EditorField>
    </>
  )
}
